import { ONEMIND_POCAAS_CONSTANTS } from "./constants";
import { Stack } from "@chakra-ui/react";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text } from "@/elements";
import CardsList from "@/components/cardsList";

const WhyChooseComponent = () => {
  const TextVariant = useTextVariant();
  return (
    <Stack gap={6} align={"center"}>
      <CardsList
        columns={{ base: 1, sm: 2, md: 4 }}
        title={ONEMIND_POCAAS_CONSTANTS.title}
        desc={ONEMIND_POCAAS_CONSTANTS.desc}
        list={ONEMIND_POCAAS_CONSTANTS.list}
        spacing={{ base: 8, md: 12 }}
        hoverEffect
      />
      <Text variant={TextVariant} color="text.100">
        {ONEMIND_POCAAS_CONSTANTS.conclusion}
      </Text>
    </Stack>
  );
};

export default WhyChooseComponent;
